var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.defaultType)?_c('Oldpile',{on:{"fatherMethod":_vm.fatherMethod}}):_c('Newpile',{on:{"fatherMethod":_vm.fatherMethod}})}
var staticRenderFns = []

export { render, staticRenderFns }